// This class is used to support field navigation using the number pad.
export class FormNode {
  constructor(public id: string, public prev: string, public next: string) {}
}



// WEBPACK FOOTER //
// ./src/app/models/form-node.ts